<template>
  <div>
    <a-modal
      title="管理数据"
      :visible="visible"
      @ok="handleOk"
      width="60%"
      :keyboard="false"
      :maskClosable="false"
      @cancel="handleCancel"
      :getContainer="getContainer"
    >
      <a-form layout="inline">
        <a-form-item style="margin-bottom: 20px">
          <a-input v-model="dataForm.title" placeholder="名称"> </a-input>
        </a-form-item>
        <a-form-item>
          <a-button @click="getDataList"> 搜索 </a-button>
        </a-form-item>
        <a-form-item>
          <a-button
            @click="addOrUpdateHandle()"
            type="primary"
            v-permission="['sys:config:add']"
          >
            新增
          </a-button>
        </a-form-item>
      </a-form>
      <a-table
        :columns="columns"
        :data-source="dataList"
        :pagination="false"
        :loading="dataListLoading"
      >
        <span slot="action" slot-scope="text, record">
          <a-space>
            <a-button
              size="small"
              type="link"
              @click="addOrUpdateHandle(record.id)"
              v-permission="['sys:config:edit']"
              >编辑
            </a-button>
            <a-button
              size="small"
              type="link"
              @click="deleteHandle(record.id)"
              v-permission="['sys:config:delete']"
              >删除
            </a-button>
          </a-space>
        </span>
      </a-table>
      <a-pagination
        style="margin-top: 20px"
        show-size-changer
        :current="page"
        show-quick-jumper
        :total="total"
        @showSizeChange="showSizeChange"
        @change="pageCurrentChangeHandle"
        :show-total="(total) => `共 ${total} 条`"
      />
    </a-modal>
    <addOrUpdate ref="detailaddOrUpdate" @ok="getDataList"></addOrUpdate>
  </div>
</template>
  
<script>
import viewModule from "@/mixins/view-module";
import addOrUpdate from "./configDetailaddorupdate.vue";
export default {
  mixins: [viewModule],
  components: { addOrUpdate },
  data() {
    return {
      visible: false,
      dataForm: {
        title: "",
        pid: "",
      },
      columns: [
        {
          title: "名称",
          align: "center",
          dataIndex: "title",
          key: "title",
        },
        {
          title: "备注",
          align: "center",
          dataIndex: "remark",
          key: "remark",
        },
        {
          title: "操作",
          key: "action",
          align: "center",
          scopedSlots: { customRender: "action" },
        },
      ],
      mixinViewModuleOptions: {
        createdIsNeed: false,
        getDataListURL: "/config/pageDetail",
        deleteURL: "/config/deleteConfigDetail",
      },
    };
  },
  methods: {
    init(id = "") {
      this.visible = true;
      this.dataForm.pid = id;
      this.query();
    },
    addOrUpdateHandle(id = "") {
      this.$nextTick(() => {
        this.$refs.detailaddOrUpdate.init(id, this.dataForm.pid);
      });
    },
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.confirmLoading = true;
          const fn = this.dataForm.id ? editRole : addRole;
          fn(this.dataForm)
            .then((res) => {
              this.$message.success(
                this.dataForm.id ? "修改账号成功" : "新增账号成功"
              );
              this.handleCancel();
              this.$emit("ok");
            })
            .finally(() => {
              let a = setTimeout(() => {
                clearTimeout(a);
                this.confirmLoading = false;
              }, 500);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleCancel() {
      console.log("Clicked cancel button");
      this.visible = false;
    },
    getContainer(){
      return document.getElementById("bodyContnet")
    }
  },
};
</script>
  
<style></style>